import { createHttpEndpoint } from '../../utils'

import type {
  CategoryAttribute,
  GetCategories,
  GetCategoriesLeafLight,
  GetCategoriesParams,
  GetCategoryAttributesParams,
} from './categories.types'

/**
 * List Bm Catalog Category
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-access-api/definition#tag/Categories/paths/~1bm~1catalog~1categories~1/get}
 */
export const getCategories = createHttpEndpoint<
  GetCategories,
  GetCategoriesParams
>({
  method: 'GET',
  operationId: 'getCatalogCategories',
  path: '/bm/catalog/categories',
})

/**
 * Retrieves list of category Information
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-access-api/definition#tag/Categories/paths/~1bm~1category~1leaf~1light/get}
 */
export const getCategoriesLeafLight =
  createHttpEndpoint<GetCategoriesLeafLight>({
    method: 'GET',
    operationId: 'getCategoriesRequest',
    path: '/bm/category/leaf/light',
    transformResponseToCamelCase: true,
  })

/**
 * Get the attributes of a category.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-access-api/definition#tag/Categories/operation/get-bm-catalog-categories-marketplaceCategoryId-attributes}
 */
export const getCategoryAttributes = createHttpEndpoint<
  CategoryAttribute[],
  GetCategoryAttributesParams
>({
  method: 'GET',
  operationId: 'getCatalogCategoryAttributes',
  path: '/bm/catalog/categories/:categoryId/attributes',
})
